// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { Box, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
// import moment from 'moment';
// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { API, EVENT_API } from '../../Utils/API';
// import { decryptedBody } from '../../Utils/constant';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import { useLoader } from '../../Utils/LoaderContext';


// const List = () => {
//     const [event, setEvents] = useState([]);

//     const location = useLocation()
//     const { showLoader, hideLoader } = useLoader()


//     useEffect(() => {
//         fetchList();
//     }, [])

//     const getParsedJSON = (json) => {
//         let jsonString = json.replace(/\\/g, '"');
//         return JSON.parse(jsonString);
//     }

//     const fetchList = async () => {
//         showLoader();
//         const res = await API.post(EVENT_API.GET_LIST, { data: location.state?.email });
//         hideLoader();
//         if (res.data.status === 200) {
//             const temp = decryptedBody(res.data.data)
//             const data = temp.map((ele) => {
//                 const obj = {
//                     ...ele,
//                     ...getParsedJSON(ele.data),
//                 }

//                 delete obj.data

//                 return obj
//             })
//             setEvents(data)
//         }
//     }

//     return (
//         <>
//             <Grid className="product__page">
//                 <Box padding={'10px'} display={'flex'} alignItems={'center'} gap={'2px'} sx={{ backgroundColor: 'lightgrey' }}>
//                     <AccountCircleIcon />
//                     <Typography variant='h6'>
//                         {location.state?.firstname + ' ' + location.state?.lastname}
//                     </Typography>
//                 </Box>
//                 <TableContainer component={Paper}>
//                     <Table sx={{ minWidth: 650 }} aria-label="simple table">
//                         <TableHead>
//                             <TableRow>
//                                 {['IP', 'MAC ID', 'Product Type', 'Event Type', 'longitude', 'latitude', 'Date (Device Recorded)', 'Address', "Created At (Server Recorded)", "Action"].map((header) => (
//                                     <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                                 ))}
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {
//                                 location.state ?
//                                     event.map((row) => (
//                                         <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                             <TableCell align="left">{row.ip}</TableCell>
//                                             <TableCell align="left">{row.mac_id}</TableCell>
//                                             <TableCell align="left">{row.product_type}</TableCell>
//                                             <TableCell align="left">{row.event_type}</TableCell>
//                                             <TableCell align="left">{row.longitude}</TableCell>
//                                             <TableCell align="left">{row.latitude}</TableCell>
//                                             <TableCell align="left">{moment(row.date).format('LLL')}</TableCell>
//                                             <TableCell align="left">{row.address}</TableCell>
//                                             <TableCell align="left">{moment(row.createdAt).format('LLL')}</TableCell>
//                                             <TableCell align="left">
//                                                 <IconButton>
//                                                     <VisibilityIcon />
//                                                 </IconButton>
//                                             </TableCell>
//                                         </TableRow>
//                                     ))
//                                     :
//                                     <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                         Select user from user list
//                                     </TableRow>
//                             }
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             </Grid>
//         </>
//     )
// }

// export default List
import VisibilityIcon from '@mui/icons-material/Visibility';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API, EVENT_API } from '../../Utils/API';
import { decryptedBody } from '../../Utils/constant';
import { useLoader } from '../../Utils/LoaderContext';
import PageHeader from "../../Components/UI/PageHeader";
import SectionCard from "../../Components/UI/SectionCard";

const List = () => {
  const [event, setEvents] = useState([]);
  const [detailRow, setDetailRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { showLoader, hideLoader } = useLoader();

  const parseCoord = (value) => {
    if (value == null || value === '') {
      return null;
    }
    const text = String(value).toLowerCase();
    if (text.includes('not found')) {
      return null;
    }
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  };

  const mapsUrlForRow = (row) => {
    const lat = parseCoord(row?.latitude);
    const lng = parseCoord(row?.longitude);
    if (lat == null || lng == null) {
      return null;
    }
    return `https://www.google.com/maps?q=${lat},${lng}`;
  };

  const formatDetail = (value) => {
    if (value == null || value === '') {
      return '—';
    }
    return String(value);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const getParsedJSON = (json) => {
    try {
      return JSON.parse(json.replace(/\\/g, '"'));
    } catch (error) {
      console.error("Invalid JSON:", error);
      return {};
    }
  };

  const fetchList = async () => {
    try {
      setLoading(true);
      setError(null);
      showLoader();
      const res = await API.post(EVENT_API.GET_LIST, { data: location.state?.email });
      if (res.data.status === 200) {
        const temp = decryptedBody(res.data.data);
        const data = Array.isArray(temp)
          ? temp.map((ele) => {
              const obj = {
                ...ele,
                ...getParsedJSON(ele.data),
              };
              delete obj.data;
              return obj;
            })
          : [];
        setEvents(data);
      } else {
        setError(res.data.message || 'Unable to load events.');
        setEvents([]);
      }
    } catch (err) {
      console.error('Error fetching event list:', err);
      setError('Unable to load events.');
      setEvents([]);
    } finally {
      hideLoader();
      setLoading(false);
    }
  };

  const handleViewDetails = (row) => {
    setDetailRow(row);
  };

  const closeDetails = () => setDetailRow(null);

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <PageHeader
        title="User events"
        subtitle="Event logs associated with a selected user."
        actions={[
          {
            label: "User",
            icon: <AccountCircleIcon />,
            onClick: undefined,
            variant: "outlined",
            key: "user",
          },
        ]}
      />

      <SectionCard
        title={
          location.state
            ? `${location.state?.firstname ?? ""} ${location.state?.lastname ?? ""}`.trim()
            : "No user selected"
        }
        subtitle={location.state ? "Showing latest events for this user." : "Open a user and click events to view logs."}
      >
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <TableContainer>
            <Table sx={{ minWidth: 1100 }} size="small">
              <TableHead>
                <TableRow>
                  {[
                    "IP",
                    "MAC ID",
                    "Product Type",
                    "Event Type",
                    "Longitude",
                    "Latitude",
                    "Date (Device Recorded)",
                    "Address",
                    "Created At (Server Recorded)",
                    "Action",
                  ].map((header) => (
                    <TableCell key={header} sx={{ fontWeight: 800 }} align="left">
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {!location.state ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      Select a user from the users page to view events.
                    </TableCell>
                  </TableRow>
                ) : loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      {error}
                    </TableCell>
                  </TableRow>
                ) : event.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      No events recorded for this user yet.
                    </TableCell>
                  </TableRow>
                ) : (
                  event.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{row.ip}</TableCell>
                      <TableCell>{row.mac_id}</TableCell>
                      <TableCell>{row.product_type}</TableCell>
                      <TableCell>{row.event_type}</TableCell>
                      <TableCell>{row.longitude}</TableCell>
                      <TableCell>{row.latitude}</TableCell>
                      <TableCell>{moment(row.date).format("LLL")}</TableCell>
                      <TableCell sx={{ maxWidth: 360, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {row.address}
                      </TableCell>
                      <TableCell>{moment(row.createdAt).format("LLL")}</TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={() => handleViewDetails(row)}>
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </SectionCard>

      <Dialog open={Boolean(detailRow)} onClose={closeDetails} maxWidth="sm" fullWidth>
        <DialogTitle>Event details</DialogTitle>
        <DialogContent dividers>
          {detailRow ? (
            <Box sx={{ display: "grid", gap: 1.5 }}>
              {[
                ["IP", detailRow.ip],
                ["MAC ID", detailRow.mac_id],
                ["Product", detailRow.product_type],
                ["Event", detailRow.event_type],
                ["Latitude", detailRow.latitude],
                ["Longitude", detailRow.longitude],
                ["Address", detailRow.address],
                ["Device recorded", moment(detailRow.date).format("LLL")],
                ["Server recorded", moment(detailRow.createdAt).format("LLL")],
              ].map(([label, value]) => (
                <Box key={label}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
                    {label}
                  </Typography>
                  <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                    {formatDetail(value)}
                  </Typography>
                </Box>
              ))}
              {mapsUrlForRow(detailRow) ? (
                <Link
                  href={mapsUrlForRow(detailRow)}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ mt: 1 }}
                >
                  Open location in Google Maps
                </Link>
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Map link unavailable — GPS coordinates were not captured for this event.
                </Typography>
              )}
            </Box>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDetails}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default List;
